import React,{useEffect,useRef,useState} from 'react';
import {createPortal} from 'react-dom';
import CalibradorArte from '../shared/CalibradorArte';

export default function EditorDisenoEvento({campo,datos,onGuardar,onCerrar}){
 const [layout,setLayout]=useState(datos[campo]);
 const dialog=useRef(null);
 useEffect(()=>{
  const previous=document.activeElement,overflow=document.body.style.overflow;
  document.body.style.overflow='hidden';dialog.current?.focus();
  return()=>{document.body.style.overflow=overflow;previous?.focus?.();};
 },[]);
 function keys(e){
  if(e.key==='Escape'){e.preventDefault();onCerrar();}
  if(e.key==='Tab'){
   const nodes=[...dialog.current.querySelectorAll('button,input,select,textarea,a[href],[tabindex="0"]')].filter(el=>!el.disabled&&el.getClientRects().length);
   const first=nodes[0],last=nodes[nodes.length-1];
   if(e.shiftKey&&(document.activeElement===first||document.activeElement===dialog.current)){e.preventDefault();last?.focus();}
   else if(!e.shiftKey&&(document.activeElement===last||document.activeElement===dialog.current)){e.preventDefault();first?.focus();}
  }
 }
 return createPortal(<div className="ew-design-window" role="dialog" aria-modal="true" aria-labelledby="ew-design-title" tabIndex="-1" ref={dialog} onKeyDown={keys}>
  <header className="ew-design-header"><h1 id="ew-design-title">{campo==='layoutInvitacion'?'Diseño de invitación':'Diseño de entrada'}</h1><div><button type="button" onClick={onCerrar}>Cancelar</button><button type="button" className="ew-design-save" onClick={()=>onGuardar(layout)}>Guardar diseño</button></div></header>
  <div className="ew-design-content"><CalibradorArte ajustePantalla tipo={campo==='layoutInvitacion'?'invitacion':'entrada'} eventoBorrador={datos} onLayoutChange={setLayout}/></div>
 </div>,document.body);
}
